// extracted by mini-css-extract-plugin
export var bottomRightDock = "_3j-0";